import React, { useEffect, useState } from 'react';

export function Countdown(props) {
    const { initialTime, onChange } = props;
    const [remainingTime, setRemainingTime] = useState(0);
    const [isReset, setIsReset] = useState(false);

    useEffect(() => {
        const getTimeInSeconds = (timeString) => {
            if (typeof timeString === 'string') {
                const [hours, minutes, seconds] = timeString.split(':');
                return parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60 + parseInt(seconds, 10);
            }
        };
        setRemainingTime(getTimeInSeconds(initialTime ? initialTime : '00:00:00'));
    }, [initialTime]);

    useEffect(() => {
        let timer;
        if (remainingTime > 0) {
            timer = setInterval(() => {
                setRemainingTime(prevTime => prevTime - 1);
            }, 1000);
            setIsReset(false);
            //minha sessao expirrou ? R: nao == false
            onChange(false);
        } else {
            setIsReset(true);
            //minha sessao expirrou ? R: sim == true
            onChange(true);
        }
        return () => {
            clearInterval(timer);
        };
    }, [remainingTime]);

    // Função para formatar o tempo no formato "HH:MM:SS"
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    };

    if (!isReset) {
        return (
            <div>
                {`Sessão expira em ${formatTime(remainingTime)}`}
            </div>
        );
    } else {
        return (
            <div style={{ color: '#cc0000' }}>
                {'Sua sessão expirou, inicie uma nova sessão, se desejar.'}
            </div>
        );
    }
}